import { AxiosRead } from "@/repositories/clients/AxiosReadClient";
import { AxiosLandingClient } from '@/repositories/clients/AxiosLandingClient'
import { AxiosLegacyClient } from '@/repositories/clients/AxiosLegacyClient'

const resource = 'store/products';
const randomVideos = `${resource}/random_videos`
const landingLiveClasses = `index.php`
const legacyLiveClasses = `/course/freeLiveClasses`

export default {

  getRandomVideos(id,queryParams = null){
    return AxiosRead.get(`${randomVideos}?grades[]=${id}`, {
      params:{
        ...queryParams
      }
    })

  },

  getLiveVideosFromLanding(queryParams = null){
    return AxiosLandingClient.get(`${landingLiveClasses}`, {
      params:{
        ...queryParams
      }
    })
  },
  getLiveVideosFromLegacy(queryParams = null){
    return AxiosLegacyClient.get(`${legacyLiveClasses}`, {
      params:{
        ...queryParams
      }
    })
  }



}
